module.exports = __webpack_public_path__ + "static/media/Smile_Pay_Logo.fb3b0b42.png";